export const SEASON_PARTICIPANT_FIELDS = `
  seasonParticipantId
  seasonParticipantType
  team {
    id
    name
  }
  division {
    id
    name
  }
  season {
    id
    name
    isArchived
    program {
      id
      name
    }
  }
  participationRoles {
    name
  }
  registration {
    id
    type
    registrationFormId
    registrationFormName
    orderId
    registrationUrl
    registrationPaymentStatus
  }
  invitationStatus
  position
  jerseyNumber
  pendingDivisionName
  pendingTeamName
  registrantId
`;
